import ConfirmDialog from '../lib/ConfirmDialog.js';
import el from '@finn-no/create-element';

export default {
    dependencies: [
        '$element',
        'xhrservice',
        'trackingservice',
        '$controllerator',
    ],
    callable(ele, xhrservice, trackingService, controllerator) {
        const finnkode = ele.getAttribute('data-toolbox-id');

        const getEditButtons = function() {
            xhrservice
                .request({
                    url: '/user/toolboxEditButtons.json',
                    method: 'GET',
                    data: { finnkode },
                    type: 'json',
                })
                .then(handleSuccess, handleError);
        };

        function handleSuccess(data) {
            const buttonContainer = ele.querySelector(
                '[data-toolbox-edit-buttons]'
            );
            const line = document.createElement('div');
            line.classList.add('line', 'r-cols1to2');

            for (let i = 0; i < data.length; i++) {
                line.appendChild(createButton(data[i]));
                buttonContainer.appendChild(line);
            }
            controllerator.run();
        }

        function handleError(data) {
            console.log(
                `error - status code:${data.status} - ${data.messageText}`
            );
        }

        function createButton(buttonDef) {
            const unit = document.createElement('div');
            unit.classList.add('pam', 'unit');

            let elem;
            if (buttonDef.type === 'link') {
                elem = document.createElement('a');
                elem.href = buttonDef.href;
                elem.className = 'button secondary fullwidth en';
                elem.textContent = buttonDef.displayValue;
                addAccessibilityTrackingController(elem, buttonDef.actionType);
            } else if (
                buttonDef.type === 'form' &&
                buttonDef.actionType === 'replace'
            ) {
                elem = document.createElement('form');
                elem.action = buttonDef.metaInfo.apiRequest.url;
                elem.method = buttonDef.metaInfo.apiRequest.method;
                const submit = document.createElement('button');
                submit.className = 'button secondary fullwidth to';
                submit.type = 'submit';
                submit.value = buttonDef.displayValue;
                submit.textContent = buttonDef.displayValue;
                addAccessibilityTrackingController(
                    submit,
                    buttonDef.actionType
                );
                elem.appendChild(submit);
            } else if (buttonDef.type === 'form') {
                elem = document.createElement('div');
                elem.className = 'inlineify';
                let button;
                if (ele.getAttribute('data-a11yfix-toggle') === 'true') {
                    button = document.createElement('button');
                } else {
                    button = document.createElement('a');
                }

                button.classList.add(
                    't4',
                    'clickable',
                    'button',
                    'fullwidth',
                    'tre'
                );

                if (buttonDef.actionType === 'dispose') {
                    button.classList.add(
                        'button',
                        'primary',
                        'fullwidth',
                        'fire'
                    );

                    button.addEventListener('click', () => {
                        trackingService.trackEventObject({
                            ecType: 'AD',
                            ecCategory: 'MarkAsSold',
                            eventData: {
                                'ad.id': finnkode,
                            },
                        });
                    });
                }

                button.textContent = buttonDef.displayValue;

                if (
                    buttonDef.inputDialog != null &&
                    buttonDef.actionType === 'dispose'
                ) {
                    const content = buildSoldPriceContent(buttonDef);
                    button.addEventListener('click', evt => {
                        evt.stopPropagation();
                        const button = content.querySelector(
                            '[data-markAsSold-button]'
                        );
                        const price = content.querySelector('[data-soldPrice]');
                        button.addEventListener('click', () => {
                            const ar = buttonDef.metaInfo.apiRequest;
                            ar.data = {
                                soldprice: price.value,
                            };
                            const formdata = {
                                finnkode,
                                apiRequest: JSON.stringify(ar),
                            };
                            doToolboxOperation(formdata);
                        });
                        new ConfirmDialog(
                            'Marker som solgt',
                            content,
                            null,
                            'Avbryt'
                        ).show();
                    });
                    button.addEventListener('keydown', handleKeydown);
                } else {
                    button.addEventListener('click', () => {
                        const jsonString = JSON.stringify(
                            buttonDef.metaInfo.apiRequest
                        );
                        const formdata = {
                            finnkode,
                            apiRequest: jsonString,
                        };
                        confirmDialog(
                            buttonDef.confirmDialog.confirmText,
                            formdata
                        );
                    });
                }
                addAccessibilityTrackingController(
                    button,
                    buttonDef.actionType
                );
                elem.appendChild(button);
            }
            unit.appendChild(elem);
            return unit;
        }

        function addAccessibilityTrackingController(ele, actionType) {
            let controllerName;
            switch (actionType) {
                case 'edit':
                    controllerName = 'trackEditAdClick';
                    break;
                case 'start':
                    controllerName = 'trackStartClick';
                    break;
                case 'delete':
                    controllerName = 'trackDeleteClick';
                    break;
                case 'undispose':
                    controllerName = 'trackMarkAsSoldClick';
                    break;
                case 'dispose':
                    controllerName = 'trackMarkAsSoldClick';
                    break;
            }
            if (controllerName) {
                ele.setAttribute('data-controller', controllerName);
            }
        }

        function buildSoldPriceContent() {
            return el(
                'div.phm',
                null,
                el(
                    'div.formelement.man',
                    null,
                    el(
                        'div.input',
                        null,
                        el('h3.mhn', null, 'Gratulerer med salget!'),
                        el(
                            'p.mhn',
                            null,
                            'Annonsen vil markeres som solgt og dukker ikke lenger opp i søkeresultatene.'
                        ),
                        el(
                            'p.mhn',
                            null,
                            'Hva solgte du for? Med korrekte salgspriser kan vi lage enda bedre ' +
                                'salgsverktøy for deg som bruker FINN.'
                        ),
                        el(
                            'p.mhn',
                            null,
                            'Salgspris eksklusiv omregistreringsavgift:'
                        )
                    )
                ),
                el(
                    'div.formelement.mhn',
                    null,
                    el(
                        'div.input',
                        null,
                        el(
                            'label',
                            null,
                            el(
                                'input',
                                { name: 'soldPrice', 'data-soldPrice': '' },
                                ''
                            )
                        )
                    )
                ),
                el(
                    'div.formelement.mhn',
                    null,
                    el(
                        'button.fullwidth.primary',
                        { 'data-markAsSold-button': '' },
                        'Marker som solgt'
                    )
                )
            );
        }

        function doToolboxOperation(formdata) {
            xhrservice
                .request({
                    url: '/user/toolboxOperation.json',
                    method: 'POST',
                    data: formdata,
                    type: 'json',
                })
                .then(data => {
                    doAfterSuccess(data, formdata.apiRequest);
                }, doAfterError);
        }

        function confirmDialog(text, formdata) {
            // eslint-disable-next-line no-alert
            if (window.confirm(text)) {
                doToolboxOperation(formdata);
            }
        }

        function doAfterSuccess(data, apiRequest) {
            if (
                ele.getAttribute('data-review-redirect') &&
                apiRequest.indexOf('/dispose') > -1
            ) {
                location.replace(ele.getAttribute('data-review-redirect'));
            } else if (
                apiRequest.indexOf('DELETE') > -1 &&
                apiRequest.indexOf('proxy/ads/') > -1
            ) {
                location.replace('/user/ads.html');
            } else {
                removeChildren(
                    ele.querySelector('[data-toolbox-edit-confirm]')
                );
                location.reload();
            }
        }

        function doAfterError() {
            removeChildren(ele.querySelector('[data-toolbox-edit-confirm]'));
        }

        function removeChildren(parent) {
            parent.innerHTML = '';
        }

        function handleKeydown(event) {
            if (
                event.keyCode === 13 /* Enter */ ||
                event.keyCode === 32 /* Space */
            ) {
                event.stopPropagation();
                event.preventDefault();
                event.target.click();
            }
        }

        getEditButtons();
    },
};



// WEBPACK FOOTER //
// ./controllers/adOwnerToolboxEditButtons.js